export const scrollToAboutUs = (id) => {
    const aboutUsSection = document.getElementById(id);
    
    if (aboutUsSection) {
      window.scrollTo({
        top: aboutUsSection.offsetTop,
        behavior: 'smooth'
      });
    }
  };